import { useQuery } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { labelMasterQueryKeys } from './queryKeys'

export const useQueryLabelNames = () => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labelNames.all,
    queryFn: () => baseClient.getApi(LobsterMasterApi).getInternalLabelNames(),
  })
}

export const useQueryLabelAreaNames = () => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labelAreaNames.all,
    queryFn: () =>
      baseClient.getApi(LobsterMasterApi).getInternalLabelAreaNames(),
  })
}
